import { UtilityPage, PageMeta, RawData } from "@/types";

export enum ErrorName {
  WebsiteNotFound = "WEBSITE_NOT_FOUND",
  PageNotFound = "PAGE_NOT_FOUND",
  CustomPageError = "CUSTOM_PAGE_ERROR",
  WebsiteExpired = "WEBSITE_EXPIRED",
  InternalServerError = "INTERNAL_SERVER_ERROR",
}

export enum ErrorCode {
  WebsiteNotFound = 9004,
  PageNotFound = 404,
  CustomPageError = 9005,
  WebsiteExpired = 9009,
  InternalServerError = 500,
}

export enum ErrorMessage {
  WebsiteNotFound = "Website not found",
  PageNotFound = "Page not found",
  CustomPageError = "Custom error page",
  WebsiteExpired = "Website expired",
  InternalServerError = "Internal server error",
}

export interface ErrorType {
  name: ErrorName;
  code: ErrorCode;
  message: ErrorMessage;
  siteData?: RawData;
  pagesMeta?: PageMeta[];
  errorPages?: UtilityPage[];
  isUnderMaintenance?: boolean;
}

type CustomErrors = Record<ErrorName, ErrorType>;

export const Errors: CustomErrors = {
  [ErrorName.WebsiteNotFound]: {
    // Name, code, and message are needed.
    name: ErrorName.WebsiteNotFound,
    code: ErrorCode.WebsiteNotFound,
    message: ErrorMessage.WebsiteNotFound,
  },
  [ErrorName.PageNotFound]: {
    // Name, code, message, and isUnderMaintenance are needed.
    name: ErrorName.PageNotFound,
    code: ErrorCode.PageNotFound,
    message: ErrorMessage.PageNotFound,
    isUnderMaintenance: false,
  },
  [ErrorName.CustomPageError]: {
    // Name, code, message, siteData,pagesMeta, and errorPages are needed.
    name: ErrorName.CustomPageError,
    code: ErrorCode.CustomPageError,
    message: ErrorMessage.CustomPageError,
    siteData: undefined,
    pagesMeta: undefined,
    errorPages: undefined,
  },
  [ErrorName.WebsiteExpired]: {
    // Name, code, and message are needed.
    name: ErrorName.WebsiteExpired,
    code: ErrorCode.WebsiteExpired,
    message: ErrorMessage.WebsiteExpired,
  },
  [ErrorName.InternalServerError]: {
    // Name, code, and message are needed.
    name: ErrorName.InternalServerError,
    code: ErrorCode.InternalServerError,
    message: ErrorMessage.InternalServerError,
  },
};
